var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Search',{attrs:{"data":_vm.data,"keys":['title']},on:{"result":_vm.onSearch},model:{value:(_vm.searchString),callback:function ($$v) {_vm.searchString=$$v},expression:"searchString"}})}
var staticRenderFns = []

export { render, staticRenderFns }